import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import useFiltersStore from "store/useFiltersStoreNew";

// styles
import styles from "./Meili.module.scss";

export default function Meili() {
    // const [filters, setFilters] = useState<string | null>(null);
    const { filters } = useFiltersStore((state) => ({
        filters: state.filters
    }));

    console.log("filters: ", filters)

    return (
        <>
            <Helmet>
                <title>Testing Meili Search</title>
            </Helmet>
            <div className={styles["business-profile-edit-root"]}>
                {/* <div>banner section</div> */}

                <div className={styles["main-content"]}>
                    <div className={styles["side-nav"]}></div>
                    <div className={styles["content"]}>
                        {filters && (
                            <pre>
                                <code>{JSON.stringify(filters, null, 2)}</code>
                            </pre>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

// api
const baseUrl = "";

async function getMeiliFirms(params) {
    try {
        const response = await fetch(`${baseUrl}/_api/v2/search`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(params),
        });

        if (!response.ok) {
            throw new Error("Failed to fetch results data");
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}